import { baseTheme } from '@src/theme';
import { Checkbox } from 'antd';
import { CheckboxGroupProps } from 'antd/lib/checkbox';
import styled from 'styled-components';

export const StyledCheckBox = styled(Checkbox.Group)<CheckboxGroupProps>`
    .ant-checkbox-label {
        font-weight: 400;
        font-size: 16px;
    }
    .ant-checkbox-inner {
        width: 24px;
        height: 24px;
        border-radius: 8px;
        border: 2px solid
            ${(props) =>
                props.theme?.colors?.secondary?.main?.text ||
                baseTheme.colors.secondary.main.text};
        background-color: ${(props) =>
            props.theme?.colors?.secondary?.light?.contentBg ||
            baseTheme.colors.secondary.light.contentBg};
        transition: all 0.3s ease;
    }
    .ant-checkbox-disabled .ant-checkbox-inner {
        border: 2px solid
            ${(props) =>
                props.theme?.colors?.secondary?.light?.text ||
                baseTheme.colors.secondary.light.text};
    }

    .ant-checkbox-inner::after {
        width: 5px;
        height: 9px;
        left: 6px;
        top: 6px;
        transform: rotate(40deg) scale(1.3);
        transition: all 0.3s ease;
        inset-inline-start: 40%;
    }

    .ant-checkbox-checked + .ant-checkbox-label,
    .ant-checkbox-label:hover {
        transition: all 0.3s ease;
        color: ${(props) =>
            props.theme?.colors?.primary?.main?.filled ||
            baseTheme.colors.primary.main.filled};
    }

    .ant-checkbox:hover + .ant-checkbox-label {
        color: ${(props) =>
            props.theme?.colors?.primary?.main?.filled ||
            baseTheme.colors.primary.main.filled};
    }

    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: ${(props) =>
            props.theme?.colors?.primary?.main?.filled ||
            baseTheme.colors.primary.main.filled};
        border: 2px solid
            ${(props) =>
                props.theme?.colors?.primary?.main?.filled ||
                baseTheme.colors.primary.main.filled};
    }
`;
